const browsers = [
  'Chrome',
  'Safari',
  'Edge',
  'Firefox'
];

const breakpoints = [
  'mobile',
  'phablet'
];

export {
  browsers,
  breakpoints
};
